module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-ira004.d16c931e.png";